import * as React from "react";
import { Menu, Icons, Layout, NavLink } from "components";
import * as H from "hooks";
import { routes } from "configs";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  sider: {
    "& .ant-layout-sider-trigger": {
      position: "static",
      borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
    },
  },
  menu: {
    overflow: "auto",
    height: "100%",
  },
  itemGroup: {
    textAlign: "center",
  },
});

const MenuComponent = () => {
  const classes = useStyles();
  const [state, setState] = React.useState<{
    selectedKeys: string[];
    openKeys: string[];
    collapsed: boolean;
  }>({
    selectedKeys: ["dashboard"],
    openKeys: [],
    collapsed: !!localStorage.getItem("collapsedMenu"),
  });
  const { pathname } = H.useLocation();

  React.useEffect(() => {
    const openKeys = [pathname.slice(0, pathname.lastIndexOf("/"))];

    setState((prevState) => ({
      ...prevState,
      openKeys: prevState.collapsed ? prevState.openKeys : openKeys,
      selectedKeys: [pathname],
    }));
  }, [pathname, state.collapsed]);

  const onCollapse = (collapsed: boolean) => {
    if (collapsed) {
      localStorage.setItem("collapsedMenu", "true");
    } else {
      localStorage.removeItem("collapsedMenu");
    }
    setState((prev) => ({ ...prev, collapsed }));
  };
  const onMenuOpenChange = (openKeys: string[]) => {
    setState((prev) => ({
      ...prev,
      openKeys: [openKeys[openKeys.length - 1]],
    }));
  };

  return (
    <Layout.Sider
      collapsible
      collapsed={state.collapsed}
      onCollapse={onCollapse}
      theme="light"
      className={classes.sider}
    >
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={[routes.dashboard]}
        className={classes.menu}
        selectedKeys={state.selectedKeys}
        openKeys={state.openKeys}
        onOpenChange={onMenuOpenChange}
        items={[
          {
            key: routes.dashboard,
            title: "Dashboard",
            icon: <Icons.DashboardOutlined />,
            label: <NavLink to="/">Dashboard</NavLink>,
          },
          {
            key: routes.company.main,
            title: "Company",
            label: "Company",
            icon: <Icons.AppstoreAddOutlined />,
            children: [
              {
                key: routes.company.list(),
                title: "List",
                icon: <Icons.AppstoreOutlined />,
                label: <NavLink to={routes.company.list()}>List</NavLink>,
              },
            ],
          },
        ]}
      />
    </Layout.Sider>
  );
};

export default MenuComponent;
